export const messages = {
  en: {
    systemUserDetail: {
      title: 'User Information',
      userId: 'ID',
      userName: 'Name',
      idCard: 'ID Card',
      tel: 'Phone',
      sex: 'Gender',
      address: 'Address',
      userAttr: 'User Attributes',
      relatedStaff: 'Related Staff',
      relatedOwner: 'Related Owner'
    },
    userDetailAttr: {
      specCd: 'Spec Code',
      specName: 'Spec Name',
      value: 'Value'
    },
    userDetailStaff: {
      name: 'Staff Name',
      tel: 'Staff Phone',
      storeName: 'Property Company'
    },
    ownerDetailAppUser: {
      communityName: 'Community Name',
      appUserName: 'Related Owner',
      idCard: 'ID Card',
      link: 'Phone',
      state: 'Status',
      createTime: 'Create Time',
      appType: 'App Type',
      openId: 'Open ID',
      ownerDetail: 'Owner Detail',
      relatedOwner: 'Related Owner',
      phone: 'Phone',
      status: 'Status',
      applyTime: 'Apply Time',
    },
    audit: {
      title: 'Audit Information',
      state: 'Audit Status',
      selectState: 'Please select audit status',
      agree: 'Agree',
      reject: 'Reject',
      remark: 'Reason',
      remarkPlaceholder: 'Required, please fill in the reason',
      stateRequired: 'Audit status is required',
      remarkRequired: 'Reason is required'
    },
    deleteAppUserBindingOwner: {
      title: 'Please confirm your operation',
      confirm: 'Are you sure to unbind the owner?'
    },
    resetStaffPwd: {
      title: 'Please confirm your operation',
      confirm: 'Are you sure to reset the password?',
      success: 'Reset password successfully, the password is {pwd}, please change it in time'
    }
  },
  zh: {
    systemUserDetail: {
      title: '用户信息',
      userId: '编号',
      userName: '名称',
      idCard: '身份证',
      tel: '手机',
      sex: '性别',
      address: '住址',
      userAttr: '用户属性',
      relatedStaff: '关联员工',
      relatedOwner: '关联业主'
    },
    userDetailAttr: {
      specCd: '规格编号',
      specName: '规格名称',
      value: '属性值'
    },
    userDetailStaff: {
      name: '员工名称',
      tel: '员工电话',
      storeName: '物业公司'
    },
    ownerDetailAppUser: {
      communityName: '小区名称',
      appUserName: '关联业主',
      idCard: '身份证',
      link: '手机号',
      state: '状态',
      createTime: '申请时间',
      appType: '手机端类型',
      openId: 'Open ID',
      ownerDetail: '业主详情',
      relatedOwner: '关联业主',
      phone: '手机号',
      status: '状态',
      applyTime: '申请时间',
    },
    audit: {
      title: '审核信息',
      state: '审核状态',
      selectState: '请审核',
      agree: '同意',
      reject: '拒绝',
      remark: '原因',
      remarkPlaceholder: '必填，请填写原因',
      stateRequired: '审核状态不能为空',
      remarkRequired: '原因内容不能为空'
    },
    deleteAppUserBindingOwner: {
      title: '请确认您的操作',
      confirm: '确定解绑业主吗？'
    },
    resetStaffPwd: {
      title: '请确认您的操作',
      confirm: '确认是否重置密码？',
success: '修改密码成功，密码为{pwd}请及时修改密码'
    }
  },
  'zh-TW': {
    systemUserDetail: {
      title: '用戶信息',
      userId: '編號',
      userName: '名稱',
      idCard: '身份證',
      tel: '手機',
      sex: '性別',
      address: '住址',
      userAttr: '用戶屬性',
      relatedStaff: '關聯員工',
      relatedOwner: '關聯業主'
    },
    userDetailAttr: {
      specCd: '規格編號',
      specName: '規格名稱',
      value: '屬性值'
    },
    userDetailStaff: {
      name: '員工名稱',
      tel: '員工電話',
      storeName: '物业公司'
    },
    ownerDetailAppUser: {
      communityName: '小區名稱',
      appUserName: '關聯業主',
      idCard: '身份證',
      link: '手機號',
      state: '狀態',
      createTime: '申請時間',
      appType: '手機端類型',
      openId: 'Open ID',
      ownerDetail: '業主詳情',
      relatedOwner: '關聯業主',
      phone: '手機號',
      status: '狀態',
      applyTime: '申請時間',
    },
    audit: {
      title: '審核信息',
      state: '審核狀態',
      selectState: '請審核',
      agree: '同意',
      reject: '拒絕',
      remark: '原因',
      remarkPlaceholder: '必填，請填寫原因',
      stateRequired: '審核狀態不能為空',
      remarkRequired: '原因內容不能為空'
    },
    deleteAppUserBindingOwner: {
      title: '請確認您的操作',
      confirm: '確定解綁業主嗎？'
    },
    resetStaffPwd: {
      title: '請確認您的操作',
      confirm: '確認是否重置密碼？',
      success: '修改密碼成功，密碼為{pwd}請及時修改密碼'
    }
  }
}